import styled from 'styled-components';

export const TopBar = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-bottom: 0.1rem solid ${({ theme }) => theme.colors.border};
  padding: ${({ theme }) => `${theme.spacing.md} ${theme.spacing.lg}`};
  margin-bottom: ${({ theme }) => theme.spacing.xl};
`;

export const Logo = styled.div`
  font-size: 2rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.accent};
  max-width: 56rem;
  margin: 0 auto;
`;

export const Container = styled.div`
  max-width: 48rem;
  margin: 0 auto;
  padding: ${({ theme }) => `0 ${theme.spacing.lg} ${theme.spacing.xxl}`};
`;

export const Heading = styled.h1`
  font-size: 2.2rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.darkSlate};
  margin-bottom: 0.6rem;
`;

export const Subheading = styled.p`
  font-size: 1.4rem;
  color: ${({ theme }) => theme.colors.slateGrey};
  margin-bottom: ${({ theme }) => theme.spacing.xl};
  line-height: 1.5;
`;

export const Card = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 1.6rem;
  padding: ${({ theme }) => theme.spacing.xl};
  margin-bottom: ${({ theme }) => theme.spacing.lg};
`;

export const Label = styled.label`
  font-size: 1.2rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.slateGrey};
  text-transform: uppercase;
  letter-spacing: 0.05rem;
  margin-bottom: ${({ theme }) => theme.spacing.sm};
  display: block;
`;

export const PhoneRow = styled.div`
  display: flex;
  align-items: center;
  border: 0.1rem solid ${({ theme }) => theme.colors.border};
  border-radius: 1rem;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const CountrySelect = styled.select`
  border: none;
  outline: none;
  background-color: ${({ theme }) => theme.colors.surface};
  padding: ${({ theme }) => `${theme.spacing.md} ${theme.spacing.sm}`};
  font-size: 1.5rem;
  color: ${({ theme }) => theme.colors.darkSlate};
  cursor: pointer;
  flex-shrink: 0;
  appearance: none;
  -webkit-appearance: none;
  padding-right: ${({ theme }) => theme.spacing.md};
`;

export const PhoneDivider = styled.div`
  width: 0.1rem;
  align-self: stretch;
  background-color: ${({ theme }) => theme.colors.border};
`;

export const PhoneInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  padding: ${({ theme }) => theme.spacing.md};
  font-size: 1.5rem;
  color: ${({ theme }) => theme.colors.darkSlate};
  background-color: ${({ theme }) => theme.colors.white};
  min-width: 0;
`;

export const PhoneHint = styled.p`
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.slateGrey};
  margin-top: ${({ theme }) => theme.spacing.sm};
  margin-bottom: 0;
`;

export const MonthsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${({ theme }) => theme.spacing.sm};
  margin-bottom: ${({ theme }) => theme.spacing.lg};
`;

export const MonthOption = styled.div<{ $selected: boolean }>`
  padding: ${({ theme }) => theme.spacing.md};
  border-radius: 1.2rem;
  border: 0.2rem solid
    ${({ $selected, theme }) =>
      $selected ? theme.colors.accent : theme.colors.border};
  background-color: ${({ $selected, theme }) =>
    $selected ? `${theme.colors.accent}1F` : theme.colors.white};
  cursor: pointer;
  text-align: center;
  transition: all 0.15s;
`;

export const MonthLabel = styled.span<{ $selected: boolean }>`
  font-size: 1.5rem;
  font-weight: 700;
  color: ${({ $selected, theme }) =>
    $selected ? theme.colors.accent : theme.colors.darkSlate};
  display: block;
`;

export const MonthPrice = styled.span<{ $selected: boolean }>`
  font-size: 1.2rem;
  color: ${({ $selected, theme }) =>
    $selected ? theme.colors.accent : theme.colors.slateGrey};
  margin-top: 0.2rem;
  display: block;
`;

export const VerifiedBanner = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.md};
  background-color: ${({ theme }) => theme.colors.white};
  border: 0.15rem solid ${({ theme }) => theme.colors.accent};
  border-radius: 1.2rem;
  padding: ${({ theme }) => `${theme.spacing.md} ${theme.spacing.lg}`};
  margin-bottom: ${({ theme }) => theme.spacing.xl};
`;

export const VerifiedTick = styled.span`
  font-size: 2.2rem;
  color: ${({ theme }) => theme.colors.accent};
  font-weight: 700;
  flex-shrink: 0;
`;

export const VerifiedLabel = styled.div`
  font-size: 1.1rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.accent};
  text-transform: uppercase;
  letter-spacing: 0.05rem;
  margin-bottom: 0.2rem;
`;

export const VerifiedName = styled.div`
  font-size: 1.8rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.darkSlate};
`;

export const OtpInput = styled.input`
  width: 100%;
  padding: ${({ theme }) => theme.spacing.md};
  font-size: 2.8rem;
  font-weight: 700;
  letter-spacing: 1.2rem;
  border: 0.1rem solid ${({ theme }) => theme.colors.border};
  border-radius: 1rem;
  outline: none;
  color: ${({ theme }) => theme.colors.darkSlate};
  background-color: ${({ theme }) => theme.colors.white};
  box-sizing: border-box;
  text-align: center;
`;

export const BackButton = styled.button`
  display: block;
  width: 100%;
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors.slateGrey};
  font-size: 1.3rem;
  cursor: pointer;
  margin-top: ${({ theme }) => theme.spacing.md};
  text-align: center;
`;

export const Button = styled.button`
  width: 100%;
  padding: ${({ theme }) => theme.spacing.md};
  background-color: ${({ theme }) => theme.colors.accent};
  color: ${({ theme }) => theme.colors.white};
  border: none;
  border-radius: 1.2rem;
  font-size: 1.5rem;
  font-weight: 700;
  cursor: pointer;
  margin-top: ${({ theme }) => theme.spacing.lg};
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ErrorText = styled.p`
  color: ${({ theme }) => theme.colors.errorRed};
  font-size: 1.3rem;
  margin-top: ${({ theme }) => theme.spacing.sm};
  text-align: center;
`;

export const Divider = styled.div`
  height: 0.1rem;
  background-color: ${({ theme }) => theme.colors.border};
  margin: ${({ theme }) => `${theme.spacing.lg} 0`};
`;

export const PriceRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing.sm};
`;

export const PriceLabel = styled.span`
  font-size: 1.4rem;
  color: ${({ theme }) => theme.colors.slateGrey};
`;

export const PriceValue = styled.span`
  font-size: 1.6rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.darkSlate};
`;

export const TotalLabel = styled.span`
  font-size: 1.5rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.darkSlate};
`;

export const TotalValue = styled.span`
  font-size: 2rem;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.accent};
`;

export const PaymentMethods = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.sm};
  flex-wrap: wrap;
  margin-top: ${({ theme }) => theme.spacing.md};
`;

export const PaymentBadge = styled.span`
  font-size: 1.1rem;
  color: ${({ theme }) => theme.colors.slateGrey};
  background-color: ${({ theme }) => theme.colors.surface};
  border-radius: 0.6rem;
  padding: 0.2rem 0.8rem;
`;

export const TestimonialsSection = styled.div`
  margin-top: ${({ theme }) => theme.spacing.xxl};
`;

export const TestimonialsHeading = styled.h2`
  font-size: 1.8rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.darkSlate};
  margin-bottom: ${({ theme }) => theme.spacing.lg};
  text-align: center;
`;

export const TestimonialCard = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 1.6rem;
  padding: ${({ theme }) => theme.spacing.xl};
  margin-bottom: ${({ theme }) => theme.spacing.md};
  border: 0.1rem solid ${({ theme }) => theme.colors.border};
`;

export const TestimonialQuote = styled.p`
  font-size: 1.4rem;
  color: ${({ theme }) => theme.colors.slateGrey};
  line-height: 1.6;
  font-style: italic;
  margin-bottom: ${({ theme }) => theme.spacing.md};
`;

export const TestimonialFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const TestimonialAuthor = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
`;

export const TestimonialName = styled.span`
  font-size: 1.4rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.darkSlate};
`;

export const TestimonialMeta = styled.span`
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.slateGrey};
`;
